import Button from "antd/es/button";
import useModal, { CloseModal } from "./useModal";
import WarningOutlined from "@ant-design/icons/lib/icons/WarningOutlined";
import BaseDialog from "../components/BaseDialog";
import DialogFooter from "../components/DialogFooter";
import Row from "../components/Row";

interface Config<ConfirmParams = undefined> {
  message?: string;
  header?: string;
  onReject?: () => void;
  onConfirm: (params?: ConfirmParams) => void;
  customContent?: React.ReactNode;
}

export default function useConfirmAction<ConfirmParams = undefined>(config: Config<ConfirmParams>) {
  const {
    onConfirm,
    onReject,
    message = "Bạn có chắc chắn muốn xóa dữ liệu này không?",
    header = "Xóa",
    customContent,
  } = config;

  const [dialog, openConfirmDialog] = useModal();

  async function confirm(params?: ConfirmParams) {
    const result = await openConfirmDialog<boolean>((close: CloseModal<boolean>) => {
      return (
        <BaseDialog
          footer={
            <DialogFooter
              submitProps={{
                children: "Xác nhận",
                onClick: () => close(true),
              }}
              cancelProps={{
                children: "Hủy",
                onClick: () => close(),
              }}
            />
          }
          title={
            <div className="main-title">
              <Row className={"align-items-center"}>
                <Button icon={<WarningOutlined />}  variant="text" color="danger" />
                {header}
              </Row>
            </div>
          }
        >
          {customContent ? customContent : <span>{message}</span>}
        </BaseDialog>
      );
    });

    if (result === true) {
      onConfirm(params);
    } else {
      onReject?.();
    }
  }

  return {
    dialog,
    confirm,
  };
}
